import { FC } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { PROD_URL, OG_DEFAULT_IMG } from 'src/common/constants';
import { useRequestInfoContext } from 'src/common/providers/RequestInfoProvider';
import prependLocale from 'src/common/utils/prependLocale';

type MetaDescriptionTagProps = {
  canonicalPath: string;
  title: string;
  imageUrl?: string;
  description?: string;
  noIndex?: boolean;
};

const OpenGraphMetaTags: FC<MetaDescriptionTagProps> = ({
  canonicalPath,
  title,
  imageUrl,
  description,
  noIndex = false,
}) => {
  const { protocol, host } = useRequestInfoContext();
  const { locale } = useRouter();
  const canonicalUrl = new URL(canonicalPath, PROD_URL);
  canonicalUrl.pathname = prependLocale(canonicalUrl.pathname, locale);
  const ogImage = imageUrl || new URL(OG_DEFAULT_IMG, `${protocol}//${host}`).href;

  return (
    <Head>
      <meta
        property="og:site_name"
        content="Getmyboat.com"
      />
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:url"
        content={canonicalUrl.toString()}
      />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:image"
        content={ogImage}
      />
      {description && (
        <meta
          property="og:description"
          content={description}
        />
      )}
      {noIndex && (
        <meta
          name="robots"
          content="noindex"
        />
      )}
    </Head>
  );
};

export default OpenGraphMetaTags;
